export const LANGUAGE_MAP = { EN: "en", SP: "es", PT: "pt", FR: "fr" };

export const SUPPORTED_LANGUAGES = ["en", "es", "pt", "fr"];

/**
 * Languages that have static JSON translation files per tenant.
 * Any language NOT in this list will use AWS Translate dynamically.
 */
export const LANGUAGES_WITH_STATIC_FILES = ["en", "es", "pt", "fr"];

export const LANGUAGE_OPTIONS = [
  { code: "en", name: "English", nativeName: "English" },
  { code: "es", name: "Spanish", nativeName: "Español" },
  { code: "pt", name: "Portuguese", nativeName: "Português" },
  { code: "fr", name: "French", nativeName: "Français" },
];
